import { Button } from "react-bootstrap";
import { Input } from "../common/form/input";
import { z } from "zod";
import { Form } from "../common/form";

const ParentTaskBar = ({ onSearch, onNew }) => {
  return (
    <div className="py-1">
      <Form
        onSubmit={values => {
          onSearch(values.search);
        }}
        schema={z.object({
          search: z.string().optional(),
        })}
        options={{
          defaultValues: {
            search: "",
          },
        }}
      >
        {({ register, formState }) => {
          return (
            <>
              <div className="border px-2">
                <div className="d-flex gap-2 align-items-center pt-3">
                  <Input
                    type="text"
                    label=""
                    name="search"
                    placeholder="名前"
                    error={formState.errors["search"]}
                    registration={register("search")}
                  />
                  <div className="mb-3">
                    <Button type="submit">検索</Button>
                  </div>
                  <div className="mb-3">
                    <Button disabled={false} type="button" onClick={onNew}>
                      新規
                    </Button>
                  </div>
                </div>
              </div>
              <div style={{ textAlign: "end" }}></div>
            </>
          );
        }}
      </Form>
    </div>
  );
};

export default ParentTaskBar;
